import type { ThemeConfig } from 'antd';
import { theme } from 'antd';
import { colors, darkColors } from './colors';

export const getThemeConfig = (darkMode: boolean): ThemeConfig => {
  const palette = darkMode ? darkColors : colors;
  return {
    algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
    cssVar: { prefix: 'app' },
    hashed: false,
    components: {
      Button: {
        fontWeight: 500,
        borderRadius: 4,
        defaultColor: palette.primary,
        defaultBorderColor: palette.primary,
        defaultBg: palette.bgContainer,
      },
      Card: {
        headerBg: palette.bgCardHeader,
        headerHeight: 50,
      },
      DatePicker: {
        activeBorderColor: palette.primary,
        cellActiveWithRangeBg: palette.primary,
        cellHoverWithRangeBg: palette.primary,
        hoverBorderColor: palette.primary,
      },
      Input: {
        borderRadius: 4,
        activeBorderColor: palette.primary,
        hoverBorderColor: palette.primary,
        activeShadow: `0 0 0 2px ${palette.primaryTransparent}`,
      },
      Layout: {
        headerBg: darkMode ? palette.bgElevated : '#ffffff',
        bodyBg: palette.bgContainer,
      },
      Select: {
        selectorBg: palette.bgContainer,
        hoverBorderColor: palette.primary,
        activeBorderColor: palette.primary,
        activeOutlineColor: palette.primaryTransparent,
      },
      Table: {
        headerSortActiveBg: palette.primaryLight,
        headerBorderRadius: 0,
        rowSelectedBg: palette.primarySurface,
        rowSelectedHoverBg: palette.primaryLight,
      },
      Typography: {
        titleMarginTop: 0,
        titleMarginBottom: 0,
      },
    },
    token: {
      colorPrimary: palette.primary,
      colorPrimaryBg: palette.primaryTransparent,
      colorPrimaryBorder: palette.primaryBorder,

      colorLink: palette.primary,
      colorError: palette.error,
      colorSuccess: palette.success,

      colorText: palette.text,
      colorTextSecondary: palette.textSecondary,
      colorTextTertiary: palette.textTertiary,
      colorTextPlaceholder: palette.textSecondary,

      colorBorder: palette.border,
      colorBorderSecondary: palette.borderSecondary,

      colorFill: palette.fill,
      colorFillSecondary: palette.fillSecondary,
      colorBgContainer: palette.bgContainer,
      colorBgLayout: palette.bgLayout,
      colorBgElevated: palette.bgElevated,
      boxShadowTertiary: darkMode
        ? '1px 1px 2px 0px rgba(0, 0, 0, 0.35), -1px -1px 1px 0px rgba(0, 0, 0, 0.25)'
        : '1px 1px 2px 0px rgba(0, 0, 0, 0.05),  -1px -1px 1px 0px rgba(0, 0, 0, 0.03)',
    },
  };
};

export const themeConfig = getThemeConfig(false);
